import { UiCollapseComponent } from "@webapp/ui/collapse/components/collapse/collapse.component";

import { ChangeDetectorRef, Component, ElementRef, Host, Input, Optional, TemplateRef } from "@angular/core";
import { collapseMotion } from "ng-zorro-antd/core/animation";
import { NzConfigService, WithConfig } from "ng-zorro-antd/core/config";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzCollapsePanelComponent } from "ng-zorro-antd/collapse";
import { NzNoAnimationDirective } from "ng-zorro-antd/core/no-animation";

@Component({
  selector: "ui-collapse-panel",
  exportAs: "uiCollapsePanel",
  animations: [collapseMotion],
  templateUrl: "./collapse-panel.component.html",
  styleUrls: ["./collapse-panel.component.less"],
})
export class UiCollapsePanelComponent extends NzCollapsePanelComponent {
  @Input("collapsePanelActive") @InputBoolean() public nzActive = false;
  @Input("collapsePanelDisabled") @InputBoolean() public nzDisabled = false;
  @Input("collapsePanelShowArrow") @WithConfig() @InputBoolean() public nzShowArrow = true;
  @Input("collapsePanelExtra") public nzExtra?: string | TemplateRef<void>;
  @Input("collapsePanelHeader") public nzHeader?: string | TemplateRef<void>;
  @Input("collapsePanelExpandedIcon") public nzExpandedIcon?: string | TemplateRef<void>;

  constructor(
    public nzConfigService: NzConfigService,
    cdr: ChangeDetectorRef,
    @Host() nzCollapseComponent: UiCollapseComponent,
    elementRef: ElementRef,
    @Optional() noAnimation?: NzNoAnimationDirective
  ) {
    super(nzConfigService, cdr, nzCollapseComponent, elementRef, noAnimation);
  }
}
